import React, { useState, useEffect } from 'react';
import cloudApi from '../../../services/cloudApi';

const InviteMemberModal = ({ isOpen, onClose, workspaceId, onInvited }) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setEmail('');
      setError(null);
      setSubmitting(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail || submitting) return;

    setSubmitting(true);
    setError(null);
    try {
      await cloudApi.inviteWorkspaceMember(workspaceId, email.trim());
      onInvited?.(email.trim());
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to send invitation');
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
      <div className="w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 ring-1 ring-gray-200 dark:ring-gray-800 shadow-xl">
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Invite team member</h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              We'll email them a link and show them an in-app prompt next time they sign in.
            </p>
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5">
              Email
            </label>
            <input
              type="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="teammate@company.com"
              className="w-full px-3 py-2 rounded-lg ring-1 ring-gray-200 dark:ring-gray-700 focus:ring-2 focus:ring-cyan-500/60 bg-white dark:bg-gray-800/50 text-gray-900 dark:text-gray-100 text-sm outline-none"
            />
          </div>

          {error && (
            <div className="rounded-lg bg-red-50 dark:bg-red-900/20 ring-1 ring-red-200 dark:ring-red-800 px-3 py-2 text-sm text-red-700 dark:text-red-300">
              {error}
            </div>
          )}

          <div className="flex gap-3 pt-2">
            <button
              type="submit"
              disabled={!isValidEmail || submitting}
              className="px-5 py-2 text-sm font-medium bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-lg hover:from-blue-600 hover:to-cyan-600 disabled:opacity-50 transition-colors"
            >
              {submitting ? 'Sending...' : 'Send invitation'}
            </button>
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 rounded-lg ring-1 ring-gray-200 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InviteMemberModal;
